import {map as mapEndpoints} from '../../../api/api-endpoints.js'
import MappingDrawer from '../utils/MappingDrawer'
import MappingBorderDrawer from "../utils/MappingBorderDrawer"

import {DEFAULT_OPACITY, FORMED_POPUP, POP_POPUP, VILLAGE_ZOOM_ARR, ZONES} from "../config/config";
import {MAP} from "../../../config/map";

export default {
  data () {
    return {
      selectedMappingObject: null,
      selectedMappingObjectZoom: null,
      legendItems: null,
    }
  },
  computed: {
    mappingConfObject () {
      return {
        population: {
          title: 'Население',
          legends: [
            {
              endpoint: mapEndpoints.heatMapPopulationDistrict,
              valueKey: 'population',
              popup: POP_POPUP,
              style: {
                opacity: DEFAULT_OPACITY
              },
              items: [
                {title: '1-25 тыс.', min: 0, style: {color: '#fad089'}},
                {title: '25-50 тыс.', min: 25000, style: {color: '#ff9c5b'}},
                {title: '50-75 тыс.', min: 50000, style: {color: '#f5634a'}},
                {title: '75-100 тыс.', min: 75000, style: {color: '#ed313c'}},
                {title: 'от 100 тыс.', min: 100000, style: {color: '#a8016d'}}
              ]
            },
            {
              // hideLegend: true,
              showOnZoom: VILLAGE_ZOOM_ARR,
              valueKey: 'population',
              endpoint: mapEndpoints.heatMapPopulationSettlement,
              popup: POP_POPUP,
              style: {
                opacity: DEFAULT_OPACITY
              },
              items: [
                {title: '1-25 тыс.', min: 0, style: {fillColor: '#fad089', color: '#ff9c5b'}},
                {title: '25-50 тыс.', min: 25000, style: {fillColor: '#ff9c5b', color: '#ff9c5b'}},
                {title: '50-75 тыс.', min: 50000, style: {fillColor: '#f5634a', color: '#ff9c5b'}},
                {title: '75-100 тыс.', min: 75000, style: {fillColor: '#ed313c', color: '#ff9c5b'}},
                {title: 'от 100 тыс.', min: 100000, style: {fillColor: '#a8016d', color: '#ff9c5b'}}
              ]
            }
          ]
        },
        formed: {
          title: 'Количество образованных отходов',
          legends: [
            {
              endpoint: mapEndpoints.heatMapFormedDistrict,
              valueKey: 'formed',
              popup: FORMED_POPUP,
              style: {
                opacity: DEFAULT_OPACITY
              },
              items: [
                {title: '1-25 тыс.', min: 0, style: {color: '#74db54'}},
                {title: '25-50 тыс.', min: 25000, style: {color: '#bbe668'}},
                {title: '50-100 тыс.', min: 50000, style: {color: '#f6e548'}},
                {title: '100-250 тыс.', min: 100000, style: {color: '#ffc90e'}},
                {title: 'от 250 тыс.', min: 250000, style: {color: '#ed313c'}}
              ]
            },
            {
              // hideLegend: true,
              showOnZoom: VILLAGE_ZOOM_ARR,
              style: {
                opacity: DEFAULT_OPACITY
              },
              endpoint: mapEndpoints.heatMapFormedSettlement,
              valueKey: 'formed',
              popup: FORMED_POPUP,
              items: [
                {title: '1-25 тыс.', min: 0, style: {color: '#74db54'}},
                {title: '25-50 тыс.', min: 25000, style: {color: '#bbe668'}},
                {title: '50-100 тыс.', min: 50000, style: {color: '#f6e548'}},
                {title: '100-250 тыс.', min: 100000, style: {color: '#ffc90e'}},
                {title: 'от 250 тыс.', min: 250000, style: {color: '#ed313c'}}
              ]
            }
          ]
        },
        [ZONES]: {
          title: 'Зоны деятельности региональных операторов',
          legends: [
            {
              endpoint: mapEndpoints.heatMapRegOperators(3),
              popup: {
                head: 'Зона действия',
                fields: [
                  {value: 'apoName', label: 'Наименование'},
                  {value: 'name_with_type', label: 'Район'},
                  {value: 'operatorName', label: 'Региональный оператор'},
                  {value: 'total_garbage', label: 'Количество образованных отходов, тонн'},
                  {value: 'total_garbage_cubic', label: 'Количество образованных отходов, м³'},
                  {value: 'total_garbage_processing', label: 'Количество переработанных отходов, тонн'},
                  {value: 'total_garbage_cubic_processing', label: 'Количество переработанных отходов, м³'},
                  {value: 'total_garbage_storage', label: 'Количество захороненных  отходов, тонн'},
                  {value: 'total_garbage_cubic_storage', label: 'Количество захороненных  отходов, м³'},
                  {value: 'apoTotalGarbageSum', label: 'Количество образованных отходов по всей зоне, тонн'},
                  {value: 'apoTotalGarbageCubicSum', label: 'Количество образованных отходов по всей зоне, м³'},
                  {value: 'tariffLimitForecastValue', label: 'Прогнозное значение предельного тарифа на текущий регулируемый период, руб'}
                ]
              },
              valueKey: false,
              hideLegend: true,
              items: [
                {min: 0}
              ]
            }
          ]
        }
      }
    },
    mappingCurrentLegend () {
      let currentOnZoom = null
      if (this.selectedMappingObject && this.selectedMappingObjectZoom) {
        let zoom = this.selectedMappingObjectZoom
        let current = this.mappingConfObject[this.selectedMappingObject]
        current.legends.forEach(v => {
          if (v.hasOwnProperty('showOnZoom') && v.showOnZoom.indexOf(zoom) > -1) {
            currentOnZoom = v
          } else if (!currentOnZoom) {
            currentOnZoom = v
          }
          if (currentOnZoom) {
            if (!v.title) {
              currentOnZoom.title = current.title
            }
            currentOnZoom.items.forEach((item, i) => {
              currentOnZoom.items[i].style = Object.assign(
                currentOnZoom.items[i].style || {},
                v.style || {}
              )
            })
          }
        })
      }
      return currentOnZoom
    }
  },
  mounted () {
    this.setMappingObjectFromRoute()
    this.mappingDrawer = new MappingDrawer(this.map, this)
  },
  watch: {
    '$route': 'setMappingObjectFromRoute',
    'mappingCurrentLegend': 'onMappingCurrentLegend'
  },
  methods: {
    drawBorders () {
      this.borderDrawer = new MappingBorderDrawer(this.map, this)
      this.borderDrawer.drawAll(this.getMapPolygon(), this.mapBorders)
    },
    onMappingCurrentLegend () {
      if (this.selectedMappingObject === ZONES) {
        this.mappingDrawer.clearPoly()
        this.borderDrawer.drawLocality(this.mapBorders, true)
        this.borderDrawer.bringToFront()
        this.borderDrawer.attachPopups(this.mappingCurrentLegend)
      } else {
        this.borderDrawer.drawLocality(this.mapBorders, false)
        this.borderDrawer.bringToBack()
        this.borderDrawer.detachPopups()
        this.fetchMappingLegendData(this.mappingCurrentLegend)
      }
    },
    fetchMappingLegendData: async function (legend) {
      if (legend && legend.endpoint) {
        const endpoint = legend.endpoint()
        if (this.mappingDrawer.isPolyDrawed(endpoint)) {
          return
        }
        this.mappingLock()
        let data = this.$store.getters.readUrlEndpoint(endpoint)
        if (!data) {
          this.$bar.start()
          const res = await this.$store.dispatch('updateUrlEndpoint', {
            endpoint,
            notReactive: true
          })
          data = res.data
          this.$bar.finish()
        }
        try {
          this.mappingDrawer.setPolyData(data, legend, endpoint)
        } catch (e) {
          console.error(e)
          this.$store.commit('mutateError', e)
        }
        this.mappingUnLock()
      } else {
        this.mappingLock()
        this.mappingDrawer.clearPoly()
        this.mappingUnLock()
      }
    },
    mappingLock () {
      this.lockRoute()
      this.layersLoading = true
    },
    mappingUnLock () {
      this.layersLoading = false
      this.unLockRoute()
      this.updateRouteStateFromMap()
    },
    setSelectedMappingObject (v) {
      this.selectedMappingObject = v
      this.replaceRoute({selectedMappingObject: v})
      const endpoint = mapEndpoints.mapLegend(v, this.$route.query.zoom);
      if (endpoint) {
        this.$store.dispatch('updateUrlEndpoint', {
          endpoint,
          notReactive: true,
          fromCache: false
        }).then(res => {
          this.legendItems = res.data.data;
        })
      }
    },
    setMappingObjectFromRoute () {
      if (this.$route.query && this.$route.query.selectedMappingObject) {
        this.setSelectedMappingObject(this.$route.query.selectedMappingObject)
      }
      if (this.$route.query && this.$route.query.zoom) {
        // fix: repalce reactive state by unreactive this.$route.query.zoom
        this.selectedMappingObjectZoom = this.$route.query.zoom * 1
      } else if (this.map) {
        this.selectedMappingObjectZoom = this.map.getZoom() * 1
      }
    }
  }
}
